import {
  ClientLoaderFunction,
  ClientLoaderFunctionArgs,
  LoaderFunction,
  LoaderFunctionArgs,
  RouterContextProvider,
} from 'react-router';
import { UserGroup } from '@/amplify/is-in-group.ts';
import { redirectForProtectedSession, sessionContext } from '@/session.ts';

type ProtectedLoaderOpts = {
  groups?: UserGroup[];
};

export const protectLoader = <
  Args extends {
    request: Request;
    context: Readonly<RouterContextProvider>;
  } = ClientLoaderFunctionArgs,
  Data extends ReturnType<ClientLoaderFunction> = null,
>(
  fn: (args: Args) => Data = () => null as Data,
  opts: ProtectedLoaderOpts = {},
) => {
  async function protectedLoader(args: Args) {
    return (
      redirectForProtectedSession(
        args.context.get(sessionContext),
        args.request,
        opts,
      ) || fn(args)
    );
  }

  protectedLoader.hydrate = true;

  return protectedLoader;
};

export const protectServerLoader = <
  Args extends LoaderFunctionArgs<Readonly<RouterContextProvider>>,
  Data extends ReturnType<LoaderFunction> = null,
>(
  fn: (args: Args) => Data = () => null as Data,
  opts: ProtectedLoaderOpts = {},
) =>
  async function protectedServerLoader(args: Args) {
    return (
      redirectForProtectedSession(
        args.context.get(sessionContext),
        args.request,
        opts,
      ) || fn(args)
    );
  };

export type ProtectedLoaderData<Loader extends ClientLoaderFunction> = Exclude<
  Awaited<ReturnType<Loader>>,
  Response
>;
